class ProductMessage extends HTMLElement {
  variantChangeUnsubscriber = undefined;

  connectedCallback() {
    this.wholeCakeIds = new Set(
      (this.dataset.wholeCakeIds || '').split(',').filter(Boolean).map(Number)
    );
    this.showAlways = this.dataset.showAlways === 'true';
    this.input = this.querySelector('.product-message__input');
    this.counter = this.querySelector('.product-message__count');

    if (!this.showAlways) {
      const initialVariantId = parseInt(this.dataset.selectedVariant, 10);
      if (initialVariantId) this.updateVisibility(initialVariantId);
    }

    // Character counter
    if (this.input) {
      this.input.addEventListener('input', () => {
        if (this.counter) this.counter.textContent = this.input.value.length;
      });
    }

    if (!this.showAlways) {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== this.dataset.sectionId) return;
        this.updateVisibility(event.data.variant?.id);
      });
    }
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
  }

  updateVisibility(variantId) {
    if (this.wholeCakeIds.has(variantId)) {
      this.style.display = '';
      if (this.counter && this.input) this.counter.textContent = this.input.value.length;
    } else {
      this.style.display = 'none';
      if (this.input) this.input.value = '';
      if (this.counter) this.counter.textContent = '0';
    }
  }
}

if (!customElements.get('product-message')) {
  customElements.define('product-message', ProductMessage);
}

// --- Cart page editor ---
// Event delegation on document survives Dawn's AJAX cart re-renders.
// Counter and save button initial state are set in Liquid, so no init pass needed.
// Guard prevents duplicate listeners when the script is loaded on both product and cart pages.
if (!window.__productMessageCartListenersAdded) {
  window.__productMessageCartListenersAdded = true;

  // Stop change events from our inputs reaching Dawn's CartItems.onChange, which
  // treats any change event inside <cart-items> as a quantity input change and crashes
  // when it can't find data-index on our element.
  document.addEventListener('change', (e) => {
    if (e.target.matches('.product-message-cart-editor .product-message__input')) {
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('input', (e) => {
    if (!e.target.matches('.product-message-cart-editor .product-message__input')) return;

    const editor = e.target.closest('.product-message-cart-editor');
    const saveBtn = editor?.querySelector('.product-message-cart-editor__save');
    const counter = editor?.querySelector('.product-message__count');

    if (counter) counter.textContent = e.target.value.length;

    if (saveBtn) {
      const trimmedNew = e.target.value.trim();
      const trimmedOriginal = (e.target.dataset.original || '').trim();
      saveBtn.style.display = trimmedNew !== trimmedOriginal ? '' : 'none';
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.matches('.product-message-cart-editor__save')) return;

    const tr = e.target.closest('.cart-item');
    const editor = e.target.closest('.product-message-cart-editor');
    const input = editor?.querySelector('.product-message__input');
    const errorEl = editor?.querySelector('.product-message-cart-editor__error');

    if (!tr || !input) return;

    updateCartMessage(tr, input, e.target, errorEl);
  });
}

async function updateCartMessage(tr, input, saveBtn, errorEl) {
  const line = parseInt(tr.dataset.line, 10);
  const quantity = parseInt(tr.dataset.quantity, 10);
  const newMessage = input.value.trim();

  let props;
  try {
    const parsed = JSON.parse(tr.dataset.properties);
    props = Array.isArray(parsed)
      ? Object.fromEntries(parsed)
      : (parsed && typeof parsed === 'object' ? parsed : {});
  } catch {
    props = {};
  }

  if (newMessage) {
    props['Custom Message'] = newMessage;
  } else {
    delete props['Custom Message'];
  }

  saveBtn.disabled = true;
  if (errorEl) errorEl.style.display = 'none';

  try {
    const res = await fetch('/cart/change.js', {
      ...fetchConfig(),
      body: JSON.stringify({ line, quantity, properties: props }),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.description || data.message || 'Please try again.');
    }
  } catch (err) {
    if (errorEl) {
      errorEl.textContent = `Could not update message — ${err.message}`;
      errorEl.style.display = '';
    }
    saveBtn.disabled = false;
    return;
  }

  window.location.reload();
}
